export default __webpack_public_path__ + "static/media/landingBackground2Mobile.fa147bca.png";